import { CashbackClaimingFrequency, CashbackWinType, LevelConditionType } from '../enums';
import { T } from './translation-keys';

export const CashbackWinTypeThemes = {
  [CashbackWinType.CasinoWallet]: 'yellow',
  [CashbackWinType.Freebet]: 'yellow'
};

export const CashbackWinTypeInfoKeys = {
  [CashbackWinType.CasinoWallet]: T.CASHBACK_INFO_REAL_MONEY,
  [CashbackWinType.Freebet]: T.CASHBACK_INFO_FREEBET
};

export const REWARD_METER_KEY = 'rewardMeterPopup';

export const CashbackClaimingFrequencyKeys = {
  [CashbackClaimingFrequency.Daily]: T.CASHBACK_DAILY,
  [CashbackClaimingFrequency.Weekly]: T.CASHBACK_WEEKLY,
  [CashbackClaimingFrequency.Monthly]: T.CASHBACK_MONTHLY
};

export const CashbackAnnouncementPopupWinTypeKeys = {
  [CashbackWinType.CasinoWallet]: T.CASHBACK_ANNOUNCEMENT_POPUP_REAL_MONEY,
  [CashbackWinType.Freebet]: T.CASHBACK_ANNOUNCEMENT_POPUP_FREEBET
};

export const CashbackAnnouncementPopupFrequencyKeys = {
  [CashbackClaimingFrequency.Daily]: T.CASHBACK_ANNOUNCEMENT_POPUP_DAILY,
  [CashbackClaimingFrequency.Weekly]: T.CASHBACK_ANNOUNCEMENT_POPUP_WEEKLY,
  [CashbackClaimingFrequency.Monthly]: T.CASHBACK_ANNOUNCEMENT_POPUP_MONTHLY
};

export const RewardsLevelColors = ['green', 'blue', 'orange', 'purple'] as const;

export type RewardsLevelColor = typeof RewardsLevelColors[number];

export const LevelConditionShortKeys: Record<LevelConditionType, string> = {
  [LevelConditionType.Turnover]: T.REWARDS_CONDITION_TURNOVER_SHORT,
  [LevelConditionType.BetCount]: T.REWARDS_CONDITION_BET_COUNT_SHORT,
  [LevelConditionType.TotalWinAmount]: T.REWARDS_CONDITION_TOTAL_WIN_AMOUNT_SHORT,
  [LevelConditionType.WinCount]: T.REWARDS_CONDITION_WIN_COUNT_SHORT,
  [LevelConditionType.TotalMultiplierCount]: T.REWARDS_CONDITION_TOTAL_MULTIPLIER_COUNT_SHORT,
  [LevelConditionType.BuyBonusCount]: T.REWARDS_CONDITION_BUY_BONUS_COUNT_SHORT
};

export const LevelConditionLongKeys: Record<LevelConditionType, string> = {
  [LevelConditionType.Turnover]: T.REWARDS_CONDITION_TURNOVER_LONG,
  [LevelConditionType.BetCount]: T.REWARDS_CONDITION_BET_COUNT_LONG,
  [LevelConditionType.TotalWinAmount]: T.REWARDS_CONDITION_TOTAL_WIN_AMOUNT_LONG,
  [LevelConditionType.WinCount]: T.REWARDS_CONDITION_WIN_COUNT_LONG,
  [LevelConditionType.TotalMultiplierCount]: T.REWARDS_CONDITION_TOTAL_MULTIPLIER_COUNT_LONG,
  [LevelConditionType.BuyBonusCount]: T.REWARDS_CONDITION_BUY_BONUS_COUNT_LONG
};

export const AmountBasedConditionTypes: Array<LevelConditionType> = [
  LevelConditionType.Turnover,
  LevelConditionType.TotalWinAmount
];
